export default {
  "el": {
    "colorpicker": {
      "confirm": "确定",
      "clear": "清空"
    },
    "datepicker": {
      "now": "此刻",
      "today": "今天",
      "cancel": "取消",
      "clear": "清空",
      "confirm": "确定",
      "selectDate": "选择日期",
      "selectTime": "选择时间",
      "startDate": "开始日期",
      "startTime": "开始时间",
      "endDate": "结束日期",
      "endTime": "结束时间",
      "prevYear": "前一年",
      "nextYear": "后一年",
      "prevMonth": "上个月",
      "nextMonth": "下个月",
      "year": "年",
      "month1": "1 月",
      "month2": "2 月",
      "month3": "3 月",
      "month4": "4 月",
      "month5": "5 月",
      "month6": "6 月",
      "month7": "7 月",
      "month8": "8 月",
      "month9": "9 月",
      "month10": "10 月",
      "month11": "11 月",
      "month12": "12 月",
      "week": "周",
      "weeks": {
        "sun": "日",
        "mon": "一",
        "tue": "二",
        "wed": "三",
        "thu": "四",
        "fri": "五",
        "sat": "六"
      },
      "months": {
        "jan": "一月",
        "feb": "二月",
        "mar": "三月",
        "apr": "四月",
        "may": "五月",
        "jun": "六月",
        "jul": "七月",
        "aug": "八月",
        "sep": "九月",
        "oct": "十月",
        "nov": "十一月",
        "dec": "十二月"
      }
    },
    "select": {
      "loading": "加载中",
      "noMatch": "无匹配数据",
      "noData": "无数据",
      "placeholder": "请选择"
    },
    "cascader": {
      "noMatch": "无匹配数据",
      "loading": "加载中",
      "placeholder": "请选择",
      "noData": "暂无数据"
    },
    "pagination": {
      "goto": "前往",
      "pagesize": "条/页",
      "total": "共 {total} 条",
      "pageClassifier": "页"
    },
    "messagebox": {
      "title": "提示",
      "confirm": "确定",
      "cancel": "取消",
      "error": "输入的数据不合法!"
    },
    "upload": {
      "deleteTip": "按 delete 键可删除",
      "delete": "删除",
      "preview": "查看图片",
      "continue": "继续上传"
    },
    "table": {
      "emptyText": "暂无数据",
      "confirmFilter": "筛选",
      "resetFilter": "重置",
      "clearFilter": "全部",
      "sumText": "合计"
    },
    "tree": {
      "emptyText": "暂无数据"
    },
    "transfer": {
      "noMatch": "无匹配数据",
      "noData": "无数据",
      "titles": [
        "列表 1",
        "列表 2"
      ],
      "filterPlaceholder": "请输入搜索内容",
      "noCheckedFormat": "共 {total} 项",
      "hasCheckedFormat": "已选 {checked}/{total} 项"
    },
    "image": {
      "error": "加载失败"
    },
    "pageHeader": {
      "title": "返回"
    },
    "popconfirm": {
      "confirmButtonText": "确定",
      "cancelButtonText": "取消"
    },
    "empty": {
      "description": "暂无数据"
    }
  },
  login: {
    title: "登录",
    message: "欢迎使用，请先登录您的账号",
    phone: "手机号码",
    pass: "密码",
    phoneError: "请输入数字格式账号",
    passError: "请输入包含大写字母、小写字母、数字、特殊符号的8-64位密码",
    button: "登录",
    codeTitle: "安全校验",
    codeSuc: "确定",
    codeClo: "取消",
    codeError: "请输入6位数字验证码",
    codeType1: "短信验证码",
    codeType2: "谷歌验证码",
    sendCode: "短信发送成功，请注意查收",
    phoneLogin: "手机号登录",
    emailLogin: "邮箱登录",
    emailErr: "请输入邮箱格式账号",
    email: "邮箱",
    emailCode: "邮箱验证码",
    emailSendCode: "邮箱验证码发送成功，请注意查收",
    codeText: "中国",
  },
  header: {
    setpass: "修改登录密码",
    outLogin: "退出登录",
    setPass: {
      title: "修改密码",
      phone: "手机号码",
      user: "用户昵称",
      old: "旧密码",
      oldError: "请输入包含大写字母、小写字母、数字、特殊符号的8-64位密码",
      new: "新密码",
      newError: "请输入包含大写字母、小写字母、数字、特殊符号的8-64位密码",
      com: "确认新密码",
      comError: "两次新密码不一致",
      yes: "确定",
      no: "取消",
    },
    google: {
      bind: "绑定谷歌验证码",
      unBind: "关闭谷歌验证码",
      title1: "下载谷歌验证器APP",
      mess1:
        "iOS用户登录App Store搜索“Authenticator”下载。安卓用户登录应用商店或使用手机浏览器搜索“谷歌验证器”下载。",
      title2: "使用谷歌身份验证器扫描二维码或手动输入密钥",
      mess2: "打开谷歌验证器，扫描下方二维码或手动输入下述密钥添加验证令牌",
      copy: "复制",
      title3: "完成绑定",
      mess3:
        "密钥用于手机更换或遗失时找回谷歌验证器，绑定前请务必将下述密钥备份保存。",
      phone: "手机验证码",
      google: "谷歌验证码",
      copySuccess: "复制成功",
      goBind: '去绑定',
    },
  },
  common: {
    title: "合约经纪人管理系统",
    noData: "暂无数据",
    noFind: "没有符合条件的数据",
    find: "操作",
    list: "数据列表",
    search: "搜索",
    perPage: "每页显示条数",
    firstPage: "首页",
    prePage: "前一页",
    nextPage: "后一页",
    lastPage: "尾页",
    getCode: "获取验证码",
    geetest: "等待滑动验证",
    idType: "关键字类型",
    noPage: "未找到当前页面",
    phone: "手机号",
    exportTit: '导出',
    download: "下载",
    export: "导出CSV",
    exportSuccess: "导出成功",
    exportError: "导出失败",
    exportIng: "正在导出...",
    operation: "Operation",
    enter: "Please input",
    pagesTotal1: "共",
    pagesTotal2: "条",
    save: "保存",
    cancel: "取消",
    alter: "提示信息",
    nodata: "暂无数据",
    sub: "提交",
    codeSuc: "确定",
    query: "查询",
    add: "添加",
    newAdd: "新增",
    editor: "编辑",
    all: "全部",
    del: "删除",
    delClass: "删除分类",
    addClass: "添加分类",
    stick: "置顶",
    view: "查看",
    repeal: "撤销",
    language: "语言",
    startDate: "请选择开始日期",
    endDate: "请选择结束日期",
    tip: "提示",
    continue: "继续",
    reset: "重置",
    chooseTip: "请选择",
    close: "关闭",
    open: "开启",
    clientName: "商户",
    client: "商户",
    sort: "序号",
    uid: "用户UID",
    usetId: "用户UID",
    symbol: "币种",
    type: "类型",
    time: "开通时间",
    back: "返回",
    date: "时间",
    money: "金额",
    contract: "合约",
    contractName: "合约名称",
    systemUid: "合约系统用户UID",
    yes: "是",
    no: "否",
    coin: "币对",
    delTip: "删除数据后，无法找回，是否继续删除?",
    configName: "配置名称",
    success: "成功",
  },
  common_language: {
    save: "保存",
    cancel: "取消",
    sub: "提交",
    query: "查询",
    uploadImg: "请上传图片",
    add: "添加",
    newAdd: "新增",
    editor: "编辑",
    del: "删除",
    delClass: "删除分类",
    addClass: "添加分类",
    stick: "置顶",
    view: "查看",
    repeal: "撤销",
    language: "语言",
    hintImg: "请上传图片",
    chooseLanguage: "请至少选择一种语言",
    sortValidate: "请输入大于1的整数序号",
    hintLanguage: "请选择语言",
    startDate: "请选择开始日期",
    endDate: "请选择结束日期",
    name: "请输入正确的名称",
    china: "中国版",
    international: "国际版",
    japanese: "日本版",
    homeBoard: "首页模板",
    check: "审核",
    startMinDate: "开始日期需小于结束日期",
    endMaxDate: "结束日期需大于开始日期",
    startMinTime: "开始时间需小于结束时间",
    endMaxTime: "结束时间需大于开始时间",
  },
  phoneCode: {
    A: [
      "阿富汗 +93+4",
      "阿尔巴尼亚 +355+8",
      "阿尔及利亚 +213+12",
      "美属萨摩亚 +684+16",
      "安道尔 +376+20",
      "安哥拉 +244+24",
      "安圭拉岛 +1264+660",
      "安提瓜和巴布达 +1268+28",
      "阿根廷 +54+32",
      "亚美尼亚 +374+51",
      "澳大利亚 +61+36",
      "奥地利 +43+40",
      "阿塞拜疆 +994+31",
    ],
    B: [
      "巴哈马 +1242+44",
      "巴林 +973+48",
      "孟加拉国 +880+50",
      "巴巴多斯 +1246+52",
      "白俄罗斯 +375+112",
      "比利时 +32+56",
      "伯利兹 +501+84",
      "贝宁 +229+204",
      "百慕大群岛 +1441+60",
      "玻利维亚 +591+68",
      "博茨瓦纳 +267+72",
      "巴西 +55+76",
      "文莱 +673+96",
      "保加利亚 +359+100",
      "布基纳法索 +226+854",
      "布隆迪 +257+108",
    ],
    C: [
      "柬埔寨 +855+116",
      "喀麦隆 +237+120",
      "加拿大 +1+124",
      "开曼群岛 +1345+136",
      "中非共和国 +236+140",
      "乍得 +235+148",
      "智利 +56+152",
      "中国 +86+156",
      "哥伦比亚 +57+170",
      "刚果 +242+178",
      "库克群岛 +682+184",
      "哥斯达黎加 +506+188",
      "科特迪瓦 +225+384",
      "古巴 +53+192",
      "塞浦路斯 +357+196",
      "捷克共和国 +420+203",
    ],
    D: ["丹麦 +45+208", "吉布提 +253+262", "多米尼加共和国 +1890+214"],
    E: [
      "厄瓜多尔 +593+218",
      "埃及 +20+818",
      "萨尔瓦多 +503+222",
      "爱沙尼亚 +372+233",
      "埃塞俄比亚 +251+231",
    ],
    F: [
      "斐济群岛 +679+242",
      "芬兰 +358+246",
      "法国 +33+250",
      "法属圭亚那 +594+254",
      "法属波利尼西亚 +689+258",
    ],
    G: [
      "加蓬 +241+266",
      "冈比亚 +220+270",
      "乔治亚 +995+268",
      "德国 +49+276",
      "加纳 +233+288",
      "直布罗陀 +350+292",
      "希腊 +30+300",
      "格林纳达 +1809+308",
      "关岛 +1671+316",
      "危地马拉 +502+320",
      "几内亚 +224+324",
      "圭亚那 +592+328",
    ],
    H: [
      "海地 +509+332",
      "洪都拉斯 +504+340",
      "中国香港 +852+344",
      "匈牙利 +36+348",
    ],
    I: [
      "冰岛 +354+352",
      "印度 +91+356",
      "印度尼西亚 +62+360",
      "伊朗 +98+364",
      "伊拉克 +964+368",
      "爱尔兰 +353+372",
      "以色列 +972+376",
      "意大利 +39+380",
    ],
    J: ["牙买加 +1876+388", "日本 +81+392", "约旦 +962+400"],
    K: [
      "哈萨克斯坦 +7+398",
      "肯尼亚 +254+404",
      "朝鲜 +850+408",
      "韩国 +82+410",
      "科威特 +965+414",
      "吉尔吉斯斯坦 +331+417",
    ],
    L: [
      "老挝 +856+418",
      "拉脱维亚 +371+428",
      "黎巴嫩 +961+422",
      "莱索托 +266+426",
      "利比里亚 +231+430",
      "利比亚 +218+434",
      "列支敦士登 +423+438",
      "立陶宛 +370+440",
      "卢森堡 +352+442",
    ],
    M: [
      "中国澳门 +853+446",
      "马达加斯加 +261+450",
      "马拉维 +265+454",
      "马来西亚 +60+458",
      "马尔代夫 +960+462",
      "马里 +223+466",
      "马耳他 +356+470",
      "马提尼克岛 +596+474",
      "毛里求斯 +230+480",
      "墨西哥 +52+484",
      "摩尔多瓦 +373+498",
      "摩纳哥 +377+492",
      "蒙古 +976+496",
      "蒙特塞拉特 +1664+500",
      "摩洛哥 +212+504",
      "莫桑比克 +258+508",
      "缅甸 +95+104",
    ],
    N: [
      "纳米比亚 +264+516",
      "瑙鲁 +674+520",
      "尼泊尔 +977+524",
      "荷兰 +31+528",
      "荷属安的列斯群岛 +599+530",
      "新西兰 +64+554",
      "尼加拉瓜 +505+558",
      "尼日尔 +227+562",
      "尼日利亚 +234+566",
      "挪威 +47+578",
    ],
    O: ["阿曼 +968+512"],
    P: [
      "巴基斯坦 +92+586",
      "巴拿马 +507+591",
      "巴布亚新几内亚 +675+598",
      "巴拉圭 +595+600",
      "秘鲁 +51+604",
      "菲律宾 +63+608",
      "波兰 +48+616",
      "葡萄牙 +351+620",
      "波多黎各 +1787+630",
    ],
    Q: ["卡塔尔 +974+634"],
    R: ["留尼汪岛 +262+638", "罗马尼亚 +40+642", "俄罗斯 +7+643"],
    S: [
      "圣卢西亚 +1758+662",
      "圣文森特和格林纳丁斯 +1784+670",
      "萨摩亚 +685+882",
      "圣马力诺 +378+674",
      "圣多美和普林西比 +239+678",
      "沙特阿拉伯 +966+682",
      "塞内加尔 +221+686",
      "塞舌尔 +248+690",
      "塞拉利昂 +232+694",
      "新加坡 +65+702",
      "斯洛伐克 +421+703",
      "斯洛文尼亚 +386+705",
      "所罗门群岛 +677+90",
      "索马里 +252+706",
      "南非 +27+710",
      "西班牙 +34+724",
      "斯里兰卡 +94+144",
      "苏丹 +249+736",
      "苏里南 +597+740",
      "斯威士兰 +268+748",
      "瑞典 +46+752",
      "瑞士 +41+756",
      "叙利亚 +963+760",
    ],
    T: [
      "中国台湾 +886+158",
      "塔吉克斯坦 +992+762",
      "坦桑尼亚 +255+834",
      "泰国 +66+764",
      "多哥 +228+768",
      "汤加 +676+776",
      "特立尼达和多巴哥 +1809+780",
      "突尼斯 +216+788",
      "土耳其 +90+792",
      "土库曼斯坦 +993+795",
    ],
    U: [
      "乌干达 +256+800",
      "乌克兰 +380+804",
      "阿拉伯联合酋长国 +971+784",
      "英国 +44+826",
      "美国 +1+840",
      "乌拉圭 +598+858",
      "乌兹别克斯坦 +233+860",
    ],
    V: ["委内瑞拉 +58+862", "越南 +84+704"],
    Y: ["也门 +967+887"],
    Z: ["赞比亚 +260+894", "津巴布韦 +263+716"],
  },
  roleManagement: {
    roleName: "角色名称",
    rlType: "角色类型",
    rlType1: "超级管理员",
    rlType2: "普通管理员",
    delTip: "确定要删除该角色吗?",
    delTip1: "删除成功",
    roleErr: "请输入角色名称，最多100个字符",
    merchantTypeErr: "请选择角色类型",
    treeData: "权限",
    roleText: "请输入角色名称",
    modalTitle1: "添加角色",
    modalTitle2: "编辑角色",
    roleText1: "角色名称支持中文、英文、数字",
    roleRoot: "请选择角色权限",
  },
  userManagement: {
    clientName: "商户名称",
    phone: "手机号",
    closeGoogle: "关闭谷歌验证",
    loginThaw: "登录解冻",
    resetPassword: "重置密码",
    nickname: "用户昵称",
    rlName: "角色",
    lastTime: "上次登录时间",
    lastIp: "登录IP",
    text: "总平台",
    modalTitle1: "添加用户",
    modalTitle2: "编辑用户",
    text1: "是否继续关闭谷歌验证码?",
    text2: "删除数据后，无法找回，是否继续删除?",
    unlockAccount: "解冻成功",
    text3: "是否继续重置密码?",
    email: "邮箱",
    clientNameEmpty: "请选择商户名称",
    userNameEmpty: "请输入用户昵称",
    userNameErr: "请输入用户昵称,可输入数字、英文、汉字",
    phoneEmpty: "请输入手机号码",
    emailEmpty: "请输入邮箱",
    emailErr: "请输入正确的邮箱格式",
    loginPwdEmpty: "请输入登录密码",
    loginPwdErr: "请输入包含大写字母、小写字母、数字、特殊符号的8-64位密码",
    roleEmpty: "请选择角色",
  },
  userRoleManage: {
    del: "解除并删除",
    roleName: "角色名称",
    roleNameTip: "最多100字符",
    text: "功能限制",
    text1: "杠杆范围(不填即不进行杠杆限制)",
    marginModel: "保证金模式限制",
    contractId: "可交易合约",
    roleNameEmpty: "请输入角色名称",
    roleNameErr: "请输入用户昵称,可输入数字、英文、汉字",
    leverErr: "最大杠杆需要大于最小杠杆",
    clientNameEmpty: "请选择商户名称",
    text2: "无限制",
    text3: "仅逐仓",
    text4: "仅全仓",
    text5: "所有已开通合约",
    sort: "序号",
    minLever: "最小杠杆",
    maxLever: "最大杠杆",
    marginModelName: "保证金模式",
    tradeContract: "允许交易的合约",
    text6: "全仓",
    text7: "逐仓",
    title1: "添加角色",
    title2: "编辑角色",
    tip1: "将恢复该角色用户为普通用户并从系统删除该角色配置，确认继续执行?",
  },
  assetsList: {
    asset: "资金流水",
    uid: "合约系统用户UID",
    totalAmount: "总资产",
    normalAmount: "余额账户",
    lockAmount: "冻结账户",
    partPositionNormal: "逐仓保证金账户",
    mtime: "更新时间",
    check: "查看用户数据",
    coinSymbol: "币种",
    positionLock: "逐仓账户",
    flatAccount: "平账",
    view: "平账详情",
    operation: "平账操作",
    txt:
      "平账结果为正，则表示此账户钱无故变少；平账结果为负，则表示此账户钱无故变多",
    detail: "查看详情",
    manual: "手动改平",
    text1: "流水类型",
    text2: "平账收入",
    text3: "平账支出",
    text4: "金额",
    text5: "币种",
    code: "谷歌验证码：",
    info: "平账信息",
    accountLock: "冻结保证金账户",
    cash: "现金资产",
    total: "流水总计",
    futuresIn: "入金",
    futuresOut: "出金",
    settlementIn: "结算盈利",
    settlementOut: "结算亏损",
    tradeFeeIn: "手续费收入",
    tradeFeeOut: "手续费支出",
    capitalFeeIn: "资金费收入",
    capitalFeeOut: "资金费支出",
    shareAmount: "分摊",
    transferIn: "转账收入",
    transferOut: "转账支出",
    flatAccountIn: "平账收入",
    flatAccountOut: "平账支出",
    error1:
      "还未绑定谷歌验证码！请先点击右上角头像打开“个人中心”绑定谷歌验证码",
    error2: "请输入6位谷歌验证码",
  },
  exportsModal: {
    text1: '导出CSV条数限制',
    text2: '当前列表为{pagesTotal}行，最大可导出为 {maxNum}行！建议重新设置条件进行分批导出！',
    text3: '继续导出',
  },
  transfer: {
    transferTool: "转账工具",
    note: "请谨慎使用!",
    title1: "公对公",
    title2: "公对私",
    title3: "私对公",
    accountType: "账户类型",
    accountBalance: "账户余额:",
    from: "从:",
    to: "转入:",
    transferAmount: "转账金额",
    remark: "备注",
    confirm: "确认",
    userContractUID: "用户合约UID",
    inputUid: "请输入正确的UID",
    code: "验证码",
    inputAmount: "请输入正确的转账金额",
    notEnough: "可用余额不足",
    systemAccount1: "系统充值账户",
    systemAccount2: "保险基金账户",
    systemAccount3: "系统手续费账户",
    userAccont1: "用户余额账户",
    userAccont2: "用户逐仓保证金账户",
    userAccont3: "用户冻结保证金账户",
    warn1: "转账一方必须是系统充值账户!",
    warn2: "划转转入和转出帐户不可相同!",
    warn3: "用户未绑定谷歌不能转账!",
    success: "划转成功",
    side: "方向",
    otherSideAcc: "对方账户",
    belongUser: "所属用户",
    amount: "金额",
    systemAcc: "系统账户",
    outAccount: "出金账户",
    intoAccount: "入金账户",
    text_1: "手续费归集",
    text_2:
      "使用此功能将所有合约的所有手续费转入到系统充值账户中，以快速收集手续费。",
    text_3: "归集记录请查询转账记录-备注为“手续费归集”的条目。",
    text_4: "限制：23:00-次日08:00之间不允许归集操作。",
    text_5: "币种",
    text_6: "所有保证金币种",
    text_7: "全部余额",
    text_8: "所有合约的手续费账户",
    text_9: "入金账户",
    text_10: "金额",
    text_11: "账户余额",
    text_12: "归集中",
    text_13: "一键归集",
    text_14: "有钱账户",
    text_15: "转账成功",
    text_16: "转账失败",
    text_17: "系统充值账户",
    text_18: "须知",
  },
  monitorModule: {
    conclusion: "结论",
    balancing: "平账结论",
    startAssets: "期初现金资产",
    endAssets: "期末现金资产",
    netInflow: "净流入",
    action1: "详情",
    balanceDetail: "平账明细",
    start: "期初",
    end: "期末",
    inGold: "入金",
    outGold: "出金",
    monitoringType: "监控类型",
    monitoringState: "监控状态",
    cycle: "周期",
    threshold: "阈值",
    singleAction: "单次行为监控",
    cycleAction: "周期统计监控",
    singleOutAmount: "单次大额出金监控",
    singleInAmount: "单次大额入金监控",
    totalOutAmount: "累计大额出金监控",
    totalOutFrequency: "累计高频出金监控",
    totalInFrequency: "累计高频入金监控",
    userAssetGrowth: "用户资产增长过多监控",
    userAssetGrowthRate: "用户资产增长过快监控",
    monitorAdd: "添加监控",
    monitorEdit: "编辑监控",
    monitoringSwitch: "监控开启/关闭",
    error1: "请输入周期",
    error2: "请输入大于0的阈值",
    error3: "请输入谷歌验证码",
    findTime: "发现时间",
    memo: "异常内容",
    balanceAmount: "平账",
    balanceAmountUn: "不平",
    total: "总计",
    userAssets: "用户资产",
    insuranceFund: "保险基金",
    systemAccount: "系统充值账户",
    assetsNetInflow: "净入金",
    googleTip: "请先绑定谷歌验证码",
    text1: "对账结果",
    text2: "现金资产",
    text3: "流水统计",
    text4: "总入金",
    text5: "总出金",
    action2: "设置",
    action3: "参数",
  },
  delivery: {
    closingType: '平仓类型',
    merchantORuserID: '商户ID/用户ID',
    contractPair: '合约交易对',
    closeRate: '平仓价格',
    isCancel: '是否撤销委托',
    entrustStatus: '委托状态',
    startTime: '执行时间',
    merchantIDErr0: '请输入商户合约ID',
    merchantIDErr1: '请输入用户合约ID',
    merchantIDErr2: "相邻两个ID之间用英式逗号隔开",
    merchantIDErr3: "最多可输入1000个ID",
    action: '执行',
    closingTypeList: ['商户平仓', '用户平仓', '交割平仓'],
    closingPriceList: ['市价', '限价'],
    text1: '近30分钟标记价格平均值',
    text2: '请输入价格',
    text3: '增加平仓设置',
    text4: '新增平仓',
    text5: '确定要取消平仓设置吗',
    text6: '取消平仓',
    text7: '谷歌验证',
    statusType: ['待执行', '执行中', '执行成功', '执行失败', '已取消'],
    typeTxt1: '系统平仓',
    typeTxt2: '系统交割',
    typeTxt3: '系统撤销'
  },
  realStatistics: {
    dateArr: ['近1周', '近1月', '近3月', '近6月'],
    info: '说明：统计数据不包含模拟合约数据，对于不同保证金币种的合约，交易量会根据查询时的汇率进行折算，可能存在误差',
    ttitleTxt: '交易量',
    ttitleTxt1: '用户盈亏',
    ttitleTxt2: '合约出入金',
    ttitleTxt3: '资产总额',
    exportTxt: '导出',
    chartTxt1: '单日用户盈亏',
    chartTxt2: '累计用户盈亏',
    chartTxt3: '总手续费',
    chartTxt4: '总流入',
    chartTxt5: '总流出',
    month: '月',
    monthList: ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  },
  "publicManage": {
    "lanset": {
      "set": "高级设置",
      "addlan": "添加语言",
      "addNote": "新增语言模版默认为英文",
      "lanList": "语言列表",
      "reset": "还原",
      "sort": "序号",
      "fileName": "文件名",
      "resetNote": "此操作会将修改内容还原成默认版本，是否确认？",
      "warn1": "根据您的需要在“编辑语言包”区域进行修改;",
      "warn2": "点击“保存并下载到本地”按钮，下载修改后的语言包;",
      "warn3": "上传修改后的语言包，上传文件名应与语言的文件名保持一致;",
      "warn4": "app语言包中的%@不可删除，否则会上传失败！",
      "warn7": "app版本为5.3.3 及以上支持此功能",
      "save": "保存并下载到本地",
      "upload": "上传",
      "return": "返回",
      "confirmLeave": "是否确认离开？",
      "edit": "编辑语言包",
      "refer": "参照语言包",
      "pleaseInput": "请输入语言包内容",
      "jsonRigth": "请输入正确的json格式文件",
      "uploadjsonRigth": "请上传正确的json格式文件",
      "secound": "请将第二行改为",
      "right": "字段需要正确的占位符%@",
      "fileNameshould": "文件名应为",
      "tip": "提示",
      "ok": "确定",
      "cancel": "取消",
      "modalTitle": "您确定要添加新语种【{lang}】吗？",
      "modalText": "提示：添加完成后，请及时安排翻译，将模板语言翻译成目标语种？翻译完成后启用该语言即可在前端生效！",
      "pause": "停用",
      "startUse": "启用",
      "status": "状态",
      "statusTitle": "您确定要启用（禁用）新语种【{lang}】吗？",
      "statusText": "启用前，请确保后台系统与服务端翻译已经上传完成，两端将一起启用与禁用本语言。",
      "admin": "后台",
      "server": "服务端",
      "warn5": "文件内的替换字符%s ",
      "warn6": "文件内的代码相关的字段翻译，可以不用修改，保存原有（这些模块在后台有其他的编辑与修改入口）",
      "btn1": "下载模板文件",
      "btn2": "上传翻译文件",
      "updateTime": "更新时间",
      "serverUpload": "提示：请勿修改文件格式，且不要新增或删除模板的KEY！文件格式：*.xlsx.",
      "uploadSuccess": "上传成功",
      "tip1": "1、新增模板语言为进行翻译时，默认使用英文！",
      "tip2": "2、当新增语言列表和下拉中均不存在，请联系客服",
      "saveSuccess": "保存成功",
      "text1": "对比并备份",
      "text2": "更新语言包",
      "text3": "本文件为语言包，请下载并翻译后上传，文件名不得发生更改。\nApp仅支持5.3.3以上版本，且App语言包中的%@不可删除，否则会上传失败",
      "text4": "下载线上语言包到本地",
      "text5": "只看有变动的KEY",
      "text6": "忽略所有变动",
      "text7": "参照原文",
      "text8": "线上显示",
      "text10": "有变动",
      "text11": "忽略变动",
      "text12": "value值发生变动或者新增的KEY会被标注为「有变动」，编辑value值后会取消「有变动」状态，也可以手动忽略该变动。",
      "text13": "是否忽略当前所有变动？"
    },
    "basenav": {
      "title": "底部导航",
      "tabTitle1": "footer文章",
      "tabTitle2": "自定义footer",
      "articleTitle": "文章标题",
      "language": "语言",
      "urlName": "文章别名",
      "sort": "排序",
      "sortValidate": "请输入大于1的整数序号",
      "articleContent": "文章内容",
      "footerList": {
        "title": "标题",
        "fileName": "URL名称",
        "publisher": "发布者",
        "ctime": "时间",
        "sort": "排序",
        "operation": "操作"
      },
      "addArticle": "添加文章",
      "editorArticle": "编辑文章",
      "hintArticleContent": "请输入文章内容",
      "customFooter": "是否开启自定义footer"
    }
  },
  "positionList": {
    "contractId": "合约名称",
    "id": "仓位ID",
    "status": "仓位状态",
    "positionType": "保证金模式",
    "side": "方向",
    "volume": "持有仓位",
    "closeVolume": "已平仓位",
    "holdAmount": "仓位保证金",
    "leverageLevel": "杠杆",
    "openPrice": "开仓均价",
    "avgPrice": "持仓均价",
    "tagPrice": "标记价格",
    "realizedAmount": "已实现盈亏",
    "historyRealizedAmount": "累计盈亏",
    "cTime": "创建时间",
    "mTime": "最近变更时间",
    "text1": "持有中",
    "text2": "已平仓",
    "text3": "逐仓",
    "text4": "全仓",
    "text5": "买入",
    "text6": "卖出",
    "openTime": "开仓时间",
    "sideBuy": "多",
    "sideSell": "空",
    "mtimeTip": "每当仓位发生加减仓，增减保证金，均视为一次变更",
  },
  "entrustedList": {
    "contractId": "合约名称",
    "type": "订单类型",
    "status": "订单状态",
    "tradeRecord": "成交记录",
    "uid": "合约系统用户UID",
    "id": "订单号",
    "status1": "状态",
    "type1": "类型",
    "open": "仓位方向",
    "side": "合约方向",
    "volume": "委托数量",
    "dealVolume": "成交数量",
    "price": "委托价格",
    "avgPrice": "成交均价",
    "leverageLevel": "杠杆",
    "realizedAmount": "盈亏",
    "fee": "手续费",
    "marginCoin": "保证金币种",
    "source": "来源",
    "cTime": "创建时间",
    "mtime": "更新时间",
    "check": "查看用户数据",
    "text1": "限价单",
    "text2": "市价单",
    "text3": "初始订单",
    "text4": "新订单",
    "text5": "完全成交",
    "text6": "部分成交",
    "text7": "已撤单",
    "text8": "待撤单",
    "text9": "异常订单",
    "text10": "无法处理的异常单",
    "text11": "开仓",
    "text12": "平仓",
    "text13": "买入",
    "text14": "卖出",
    "quantity": "数量",
    "addText1": "用户主动撤销",
    "addText2": "订单异常，被系统撤销",
    "addText3": "仓位发生强平, 未成交委托被系统撤销",
    "addText4": "市价单对手盘不足",
    "addText5": "FOK订单无法全成交时被系统撤销",
    "addText6": "IOC订单无法立即成交时部分委托被系统撤销",
    "addText7": "POST ONLY订单无法成为被动单就系统撤销",
    "addText8": "仓位不存在，平仓委托被系统撤销",
    "addText9": "爆仓单",
    "addText10": "双向持仓合并爆仓单",
    "addText11": "止盈",
    "addText12": "止损",
    "addText13": "已生效",
    "addText14": "未生效",
    "addText15": "价格",
    "addText16": "订单状态",
    "addText17": "条件单委托",
    "addText18": "止盈止损",
    "addText19": "系统撤销",
    "addText20": "仓位被ADL，系统撤销",
    "addText21": "仓位被强平，系统撤销",
    "tabTxt15": "普通委托",
    "tabTxt16": "条件委托",
  },
  lanV4: {
    noPermissions: '无页面权限',
    logoTxt: '合约后台',
    logoTxt2: '经纪人后台',
    positionParam: '仓位参数',
    viewChart: '查看走势图',
    insuranceTotal: '保险基金总额',
    profitTotal: '盈亏金额总计',
    insuranceTitle: '保险基金走势',
    profitTxt: '盈亏金额',
    filterProfitTxt: '筛选日期内盈亏金额总计',
    loadingErr: '加载失败请',
    reset: '重试',
    contractID: '合约ID',
    closeContract: '关闭后该合约将不会在前端页面显示中，确定要关闭吗？',
    openContract: '开启后该合约将显示在前端页面中，确定要开启吗？',
    contractStatusOpen: '可交易',
    contractStatusClose: '已关闭',
    contractStatusOffline: '交割中',
    selectCode: '选择区号',
    reducePrice: '预估强平价',
    completeTime: '完成时间',
    hideAssets: '隐藏总资产为0的账户',
    outLogin: '退出登录成功',
    confirmDel: '确认删除?',
    updateTime: '修改时间',
    feeAccount: '手续费分成账号',
    followSet: '跟单设置',
    followTip: '关闭后，商户将无法在后台看到[商户跟单]模块',
    followTxt: '商户反向跟单',
    nextStep: '下一步',
    backEnd: '后台系统',
    transferTo: '转入',
    leveMultiple: '杠杆倍数',
    basicParam: '基础参数',
    otherConfig: '其他配置',
    btnTxt1: '继续添加币种',
    btnTxt2: '添加币对',
    symbolSuccess: '添加币种成功',
    symbolSuccess2: '添加指数价格成功',
    btnTxt3: '继续添加指数',
    indexPrice: '指数价格',
    confirmClose: '确认关闭?',
    confirmOpen: '确认开启?',
    priceSymbol: '获取价格币对',
    enabled: '已开启',
    closed: '已关闭',
    contractOtherName: '合约别名',
    contractParam: '合约参数',
    contractTab1: '正在交易',
    contractTab2: '已关闭交易',
    contractTab3: '正在配置中',
    paramStatus: '参数状态',
    release: '发布',
    releaseTip: '参数完成后可操作发布',
    step1: 'Step1 基本信息',
    step2: 'Step2 费率配置',
    step3: 'Step3 发布',
    chooseTep: '选择模版',
    previewLeverTitle: '预览杠杆配置',
    previewLadderTitle: '预览阶梯减仓',
    choosePair: '选择币对',
    prevStep: '上一步',
    nextStep: '下一步',
    saveDraft: '存草稿',
    directTxt: '直接发布',
    subjectIndex: '标的币对（指数）',
    pairParam: '币对参数',
    addTepTxt: '添加模版',
    previewTepTxt: '预览配置',
    matchTxt: '撮合结算',
    publishParam: '发布参数',
    referPrice: '开盘参考价',
    referPriceError: '请输入开盘参考价',
    priceParam: '价格参数',
    priceParamTip: '此参数会应用到使用这个币对的所有合约',
    numParam: '数量参数',
    editPairTitle: '编辑币对',
    precisionMerge: '订单簿深度聚合',
    priceChange: '最小价格波动',
    precisionMergeTip: '订单簿深度聚合（最多可选3个）',
    loading: '加载中',
    closeContractTip: '关闭后用户将看不到该合约，同时会关闭撮合，确认要关闭吗？',
    strongLeveWarn: '强平预警',
    draftStatus: '未完成',
    fundRateRange: '资金费率范围',
    delContractTip: '删除后该合约所有配置的信息无法找回',
    confirmRelease: '确认发布？',
    confirmReleaseTip: '发布后商户可添加该合约，确认要发布吗？',
    contractTip1: 'U本位合约：以 USDT 为保证金和结算币种的合约；币本位合约：以基础货币为保证金和结算币种的合约，以基础货币为保证金和结算币种的合约，如 BTCUSD, BTC 为保证金和结算币种；混合合约：以第三币种为保证金和结算币种的合约，如 BTCUSDT-EXUSD, EXUSD 为保证金和结算币种；模拟合约：以EXUSD（模拟币）为保证金和结算币种的合约。',
    contractTip2: '本参数一经创建不可修改！请确认已经在【币对管理】中创建好了该币对！币本位合约的标的币对为XXX-USD。',
    contractTip3: '本参数一经创建不可修改！请确认已设置该币种为保证金币种！U本位:【标的币对】的计价货币。币本位:为【标的币对】的标的货币。混合合约:可以灵活设置。',
    contractTip4: '本参数一经创建不可修改！混合合约是一个特殊的U本位合约，特殊在保证金可以不是计价货币。但是要给这个保证金和计价货币之间设置一个固定的汇率，意思是 1个这个保证金 = n 个计价货币。',
    contractTip5: '本参数一经创建不可修改！U本位：一张合约等于多少标的货币。币本位：一张合约等于多少计价货币。混合：同U本位一样。',
    contractTip6: '合约在前端显示的名称',
    contractTip7: '本参数一经创建不可修改！合约ID是合约的唯一标识，不可重复。可以选择给合约ID加上商户的ID，以区分合约！如：商户ID-BTC-USDT',
    contractTip8: '通过“每天开始时间”和“收取间隔”确定在每天的哪几个时间段结算资金费。',
    contractTip9: '通过“每天开始时间”和“收取间隔”确定在每天的哪几个时间段结算资金费。',
    contractTip10: '利率决定基础资金费率，当市场平稳时，资金费率会是这个值。',
    contractTip11: '用于计算冲击价格。假如在盘口买入或卖出这么多的量，价格会被拉到或砸到的位置。用于衡量盘口的深度和价格偏离。	请注意：对于反向合约，参数的单位是BTC、ETH等标的货币。',
    contractTip20: '商户设置的Taker手续费不得低于该值',
    contractTip21: '商户设置的Maker手续费不得低于该值',
    contractTip22: '实现盈亏的频率。定时结算会将未实现盈亏结算为已实现盈亏并划转到相应账户，以提高资金利用率',
    contractTip23: '保险基金补偿额 = min(穿仓损失 * 保险基金补偿比例, 保险基金剩余金额)，保险基金补偿比例越小，发生穿仓后平台保险基金补偿的额度越小',
    contractTip24: '预警保证金率 = 维持保证金率*（1+预警系数）+ taker手续费率',
    contractTip25: '请输入要加入的撮合服务器地址。如不清楚，请联系运维人员。请合理分配服务器资源。',
    contractTip26: '请输入要加入的结算服务器地址。如不清楚，请联系运维人员。请合理分配服务器资源。',
    contractTip27: '开盘的初始价格，会显示在K线上，请设置为发布时的最新价格！',
    symbolTip1: '本参数一经创建不可修改！',
    symbolTip2: '本参数一经创建不可修改！',
    symbolTip3: '当标记价格与指数价格偏离超过该值时，取合理价格作为标记价格',
    symbolTip4: '订单簿中可选择的深度聚合',
    symbolTip5: '防止用户输错价格，造成意外损失',
    symbolTip6: '单笔限价单或者市价单最小下单数量',
    symbolTip7: '单笔订单最小的价值，单位为保证金币种',
    symbolTip8: '市价单最多下的张数',
    symbolTip9: '市价单最小的价值，单位为保证金币种',
    symbolTip10: '限价单最多下的张数',
    symbolTip11: '限价单最小的价值，单位为保证金币种',
    symbolTip12: '每个合约最多同时挂的订单数，做市商在KV中设置后无此限制',
    symbolTip13: '标价价格偏离指数价格若超过设置的比例，标记价格会取合理价格。',
    baseParams: '此参数一经创建不可修改',
    depthCheckedError: '请选择订单簿深度聚合',
    contractMerchantId: "合约ID加商户标识",
    companyId: 'SAAS商户ID',
    sumCloseVolume: '已平仓总量(张)',
    liquidationVolume: '强平数量(张)',
    mergeVolume: '强平合并总量(张)',
    contractCloud: '合约云',
    date: '日期',
    adminTxt1: '商户管理员',
    adminTxt2: '平台管理员',
    adminTxt3: '超级管理员',
    insuranceOverview: '总览',
    insuranceStatement: '流水',
    feePlatform: '平台',
    feeMerchant: '商户',
    saasID: '商户SaaS ID',
    minOrderMoneyNew: '下单额精度',
    minOrderMoneyNewTip: '下单价值精度，填写示例：1，0.1，0.01。',
    Competition: '合约大赛',
    ActivityConfig: '活动配置',
    ActivityAdd: '添加活动',
    ActivityEdit: '活动编辑',
    DataMaintenance: '数据维护',
    ActivityData: '活动数据',
    BasicConfig: '基础配置',
    ActivityStatus: '活动状态',
    Unstarted: '待开始',
    Progressing: '进行中',
    Ended: '已结束',
    Online: '是否上线',
    Yes: '是',
    No: '否',
    ActivityID: '活动ID',
    ActivityName: '活动名称',
    ActivityType: '活动类型',
    TradingAndROE: '交易额&收益率',
    TradingAmount: '交易额',
    Roe: '收益率',
    ActivityTime: '活动时间',
    Participants: '参赛人数',
    EstimatedWinner: '预计奖励人数',
    Bonus: '赠金发放额(USDT)',
    BonusRecovery: '赠金回收额(USDT)',
    UpdateTime: '更新时间',
    Note: '注：该数据主要用来在前端显示当前的参赛人数，前端显示人数 = 实际人数 + 数据基础上增加的人数+排名维护人数',
    RankMaintenance: '排名维护',
    CreateUser: '创建用户',
    UserEmail: '用户邮箱',
    EmailFormat: '请填写正确的邮箱格式',
    Information: '请完善用户信息',
    ActivityNameErr: '请填写活动名称',
    ActivityTimeErr: '请选择活动时间',
    ActivityTypeErr: '请选择活动类型',
    StartTime: '开始时间',
    EndTime: '结束时间',
    actInfo: '上线后活动页面将显示活动信息、更新排行榜、发放赠金',
    actInfo2: '下线后活动页面将不显示活动信息、不更新排行榜、不发放赠金',
    actInfo3: '最多可上线一个活动，当前有其他活动已上线',
    Participation: '参赛标准',
    Kyc: '通过KYC',
    BindPhone: '绑定手机号',
    FuturesAccount: '合约账户权益>=',
    RankingRules: '排名规则',
    TradingCompetition: '交易额大赛',
    ROECompetition: '收益率大赛',
    Participate: '满足排名规则条件的用户才能参与排名和瓜分奖池',
    Cumulative: '累计交易额',
    OpeningTimes: '有效开仓次数',
    BonusSetting: '奖金设置',
    Respective: '前3名设置值为前三名分别的奖金额度，第4档的奖金设置为用户共同瓜分的奖金额度，参与奖为第4档排名后的所有有排名的用户共同瓜分。',
    No1: '第 1 名',
    No2: '第 2 名',
    No3: '第 3 名',
    No4: '第 4',
    No1: '第 1 名',
    ParticipationAward: '参与奖',
    TotalBonus: '奖金总计',
    Distribution: '奖金发放&回收',
    Recovery: '奖金形式',
    bonus: '赠金',
    No1Err: '[0,999999999],整数',
    Company: '公司合约赠金账户余额',
    insufficient: '当前余额不足，',
    insufficient2: '查看充值指引',
    DistributionTime: '赠金发放时间',
    RecoveryTime: '赠金回收时间',
    ActivityRuleErr: '请选择参赛标准',
    ActivityRuleNumErr: '请输入合约账户权益',
    ruleVolumeErr: '[0,999999999.99],最多2位小数',
    ruleRoeErr: '[-100,9999.99],最多2位小数',
    ruleOpenNumErr: '[0,10000],整数',
    ruleOpenNumUnit: '次',
    bounsStartTime: '请选择赠金发放时间',
    bounsEndTime: '请选择赠金回收时间',
    ActivityPageLink: '活动页面链接',
    CopyLink: '复制链接',
    Copy: '复制成功',
    ActivityPageBanner: '活动页面 Banner',
    Upload: '上传',
    ImageFormat: '图片格式',
    CopyLinkImg: '大小不超过',
    GameRulesLink: '比赛规则链接',
    PleaseEnterLink: '请输入链接',
    ActivityDescription: '活动说明',
    Description: '比赛规则链接',
    Description2: '不符合填写规则，请填写链接地址',
    imgRuleWeb: '(图片格式：大小不超过 5M，2560*480 px，JPG/PNG/JPEG）',
    imgRuleH5: '(图片格式：大小不超过 5M，375 *420 px，JPG/PNG/JPEG）',
    ActivityDescriptionTxt: '请输入活动说明',
    RankType: '大赛类型',
    CurrentRank: '当前排名',
    ExpectedRewardAmount: '预计奖励金额',
    tradeAmountUsdt: '交易额 (USDT)',
    RoeAmountUsdt: '收益率 (%)',
    RegistrationTime: '报名时间',
    baseData: '数据基础上增加',
    people: '人',
    ParticipantsErr: '请输入参赛人数',
    TopPeople: '配置虚拟用户，该用户将会按照配置的交易额或收益率参与用户排名，奖金发放时不会给虚拟用户发放，最多可配置 20 个用户。',
    addUser: '创建用户',
    TradingAmountErr: '活动进行中，交易额需大于等于前值',
    coAccountBalanceErr: '合约赠金账户余额不足，请先充值',
    bounsStartTimeErr: '赠金发放时间需要晚于活动的结束时间',
    bounsEndTimeErr: '赠金回收时间需要晚于赠金发放时间',
    imgRuleErr: '不符合图片规则，请重新上传',
    noticeContentErr: '请输入活动说明，最多支持输入5000字（非必填）',
    userTxt: '用户',
    sort2: '名',
    userUidErr: '请输入用户UID',
    required: '请正确填写所有必填项',
    ruleOpenNumErr2: '[4,10000],整数',
    actStartTimeErr: '活动开始日期必须小于结束日期',
    BonusTxt: '赠金',
    withLink: '有跳转',
    withOutLink: '无跳转',
    Prerequisite: '显示条件',
    HasLogged: '已登录',
    Cumulative2: '历史累计总交易额>=',
    displayTimes: '公告栏最大累计次数',
    displayTimesTip: '公告每天显示一次，显示一次公告栏累计次数+1，累计次数需小于等于最大累计次数',
    MerchantShow: '显示商户',
    noteLan: '语言',
    Bulletin: '公告标题',
    noteUrl: 'URL',
    noteStatus: '功能状态',
    noteOpen: '保存后配置的内容将显示在客户端公告栏，是否保存？',
    noteClose: '保存后将不再客户端显示公告栏，且公告栏的累计值将清零，是否保存？',
    noteErr: '只能填写正整数',
    noteErr2: '请选择显示条件',
    noteErr3: '请填写历史累计总交易额',
    noticeContentErr2: '请输入公告标题，最多支持输入500字节',
    "adtv": "日均交易额",
    "UserRank": "用户排名",
    "DailyAverage": "日均",
    "Allcontract": "所有合约",
    "IncompleteFilled": "未完全成交",
    "CompleteFilled": "完全成交",
    "Cancelled": "已撤单",
    "Abnormal": "异常订单",
    "UserAnalytics": "用户统计",
    "newUsers": "每日新增用户数",
    "NewFuturesUsers": "新增合约用户数",
    "ActiveUsers": "活跃用户数",
    "ActiveUsersTip": "所选时间段内有过订单的用户数",
    "NewToday": "本日新增",
    "NewMonth": "本月新增",
    "EffectiveUsers": "有效用户数",
    "EffectiveUsersTip": "与所选时间无关，此时合约账户内资产不为0的用户数",
    "TotalFuturesUsers": "总合约用户数",
    "NewLastMonth": "上月新增",
    "NewYesterday": "昨日新增",
    "MoM": "环比",
    "DoD": "环比",
    "MerchantTotal": "商户总览",
    "DailyStatement": "每日明细",
    "Excludemerchants": "排除总合约用户数为0的商户",
    "Excludemerchants2": "排除新增合约用户数为0的商户",
    "MerchantNew": "商户",
    "TotalBalance": "实时总资产",
    "newUid": "UID",
    "UserDetails": "用户详情",
    "CreateTime": "开通时间",
    "TotalBalanceNew": "总资产",
    "TradingVolume": "总交易额",
    "WinningRate": "胜率",
    "newLateTrade": "最近交易",
    "newContract": "合约",
    "manualClose": "手动平仓",
    "newPnl": "盈亏",
    "closingTimeNew": "最后平仓时间",
    "CompleteFilledNew": "已完全成交",
    "otherNew": "其他",
    "posNew": "仓位",
    "leverageLevelNew": "杠杆",
    "Merged": "爆仓合并仓位",
    "Liquidated": "爆仓仓位",
    "IncompleteFilledNew": "未完全成交",
    "Direction": "仓位方向",
    "positionParamNew": "仓位参数",
    "entrustVolume": "委托数量",
    "feeNew": "手续费",
    "ConditionType": "条件单类型",
    "ADLRecord": "ADL记录",
    "PositionID": "强平仓位ID",
    "entrustID": "委托ID",
    "ClosingPnL": "平仓盈亏",
    "UnrealizedPnL": "未实现盈亏",
    "BankruptcyPrice": "破产价格",
    "achievedAmountNew": "接管盈亏",
    "IFCompensation": "保险基金补偿额",
    "riskProfit": "保险基金盈亏",
    "isADL": "是否ADL",
    "ADLQuantity": "ADL数量（张）",
    "newUser": "用户",
    "ADLPrice": "ADL价格",
    "Totalequity": "总权益",
    "TotalequityTip": "总权益 = 钱包余额 + 未实现盈亏",
    "WalletBalance": "钱包余额",
    "WalletBalanceTip": "钱包中已结算的总资产，不含未实现盈亏。钱包余额 ＝ 总共净划入+ 总共已实现盈亏 + 总共净资金费用 - 总共手续费",
    "UnrealizedPnLTip": "采用标记价格计算得出的未实现盈亏",
    "CrossMargin": "全仓保证金账户",
    "AvailableNew": "可用余额",
    "ADL": "ADL单",
    "Userfees": "用户手续费",
    "Userdiscount": "用户折扣",
    "DiscountRestrictions": "折扣限制",
    "feeNewUser": "新用户",
    "Allusers": "所有用户",
    "singleUser": "单用户",
    "condition": "条件",
    "conditionTip": "注册后的用户在设置的周期内才可享受手续费折扣",
    "periodDate": "有效期",
    "periodDateTip": "只有在折扣有效期内的交易才能享受手续费折扣",
    "feeDiscount": "手续费折扣",
    "feeDiscountTip": "请输入手续费折扣率",
    "feeDiscountMax": "最大值为{feeDiscountMax}",
    "addTime": "添加时间",
    "Registrationtime": "注册时间",
    "RegistrationtimeTip": "在注册时间后注册的新用户才可享受手续费折扣",
    "RegistrationtimeTip2": "手续费率 = 初始手续费率 * （1 - 手续费折扣）",
    "RegistrationtimError": "请选择注册时间",
    "conditionError": "请输入【1，99999】的整数",
    "regAfter": "注册后",
    "dayAfter": "天内",
    "actStartTimeErr2": "开始时间必须小于结束时间",
    "periodDateErr": "请选择有效期",
    "discountPeriodDate": "有效期",
    "UidErr": "请输入UID",
    "newFeeMax": "新用户手续费折扣最大值（%）",
    "newFeeMax2": "新用户折扣最大值",
    "newFeeMaxTip": "请输入手续费折扣率",
    "allUserFeeMax": "所有用户手续费折扣最大值（%）",
    "allUserFeeMax2": "所有用户折扣最大值",
    "feeFwErr": "超过可输入范围",
    "regAfter2": "注册",
    "dayAfter2": "天内",
    "addUserDiscount": "添加用户折扣",
    "editUserDiscount": "编辑用户折扣",
    "InputRange": "可输入范围",
    "infoErr": "信息不完全，请填写所有信息",
    "maxUserLimit": "单用户手续费折扣最大值（%）",
    "maxUserLimit2": "单用户折扣最大值",
    "transferInNew": "按照流入排序时，不显示流入流出为0的用户",
    "transferOutNew": "按照流出排序时，不显示流入流出为0的用户",
    "updateDataTime": "本页数据更新于",
    "Invitefriends": "邀请好友",
    "InviteCode": "邀请码",
    "AgentRole": "经纪人角色",
    "Rebateratio": "返佣比例",
    "RebateratioSub": "下级返佣比例",
    "RebateratioTip": "下级交易后，给经纪人的手续费分成",
    "Rebateratiocash": "返现比例",
    "RebateratiocashTip": "直属下级交易后，给交易者本人的手续费分成",
    "RebateratioLever": "最高返佣等级",
    "agentChange": "更改",
    "Datascreening": "数据总览",
    "directNum": "直属下级数",
    "directNumAll": "总下级数",
    "directNumAllTip": "可以给你返佣的下级总和",
    "directNumDown": "下级经纪人数量",
    "directNumDownTip": "总下级中经纪人的数量",
    "directAmount": "下级交易额(USDT)",
    "directAmountTip": "总下级的合约交易额，非U币种按照统计时的汇率折算成USDT，包含开仓和平仓，不包含模拟合约",
    "directMy": "我的返佣(USDT)",
    "directMyChart": "我的每日返佣(USDT)",
    "directMyTip": "获得的合约返佣，非U币种按照统计时的汇率折算成USDT",
    "RebateratiocashMax": "请输入{feeDiscountMin}～{feeDiscountMax}%范围内的两位小数！",
    "RebateratiocashMaxTip": "{feeDiscountMin}～{feeDiscountMax}",
    "RebateratiocashTip2": "不能高于当前经纪人角色的一级返佣比例",
    "invitedUsers": "受邀用户数",
    "invitedUsersTip": "用户中通过邀请码注册的用户数",
    "TotalNumberUsers": "总用户数",
    "contractBrokeNum": "合约经纪人数量",
    "commissionRebates": "累计发放返佣(USDT)",
    "commissionRebatesTip": "发放给经纪人合约返佣的总和，非U币种按照统计时的汇率折算成USDT",
    "agentType0": "比例",
    "agentType1": "级差",
    "agentType2": "固定级差",
    "ReturnedCommission": "返佣对象",
    "ReturnedCommissionTip": "收到返佣的人",
    "ReturnedCommissionUid": "请输入返佣对象的UID",
    "ReturnedCommissionUid2": "请填写返佣对象的UID",
    "ReturnedCommissionMy": "我",
    "ReturnedCommissionThe": "他人",
    "ReturnedCommissionLevel": "返佣级别",
    "ReturnedCommissionLevelTip": "对于返佣对象的返佣级别",
    "Receivedcommission": "收到的返佣",
    "ReceivedcommissionTip": "含自返佣",
    "ReceivedcommissionAmount": "交易额",
    "ReceivedcommissionAmountTip": "所选返佣级别用户的合约交易额总和，非U币种按照统计时的汇率折算成USDT，包含开仓和平仓，不包含模拟合约",
    "ReceivedcommissionNum": "交易次数",
    "ReceivedcommissionNumTip": "所选返佣级别用户的合约交易次数总和，非U币种按照统计时的汇率折算成USDT，同一委托多次成交算一次交易，时间按提交时间，包含开仓和平仓，不包含模拟合约",
    "PID": "PID",
    "UIDTip": "交易并给返佣对象返佣的用户",
    "PIDTip": "上级UID",
    "ReceivedcommissionAmountTip2": "在所选时间内，该用户合约的交易额总和，非U币种按照统计时的汇率折算成USDT",
    "CommissionRebate": "返佣",
    "CommissionRebateTip": "在所选时间内，该用户给返佣对象的返佣总和，非U币种按照统计时的汇率折算成USDT",
    "agentFee": "手续费",
    "agentFeeTip": "在所选时间内，该用户合约的手续费总和，非U币种按照统计时的汇率折算成USDT",
    "Rebatedetail": "返佣明细",
    "RebateStatus": "返佣状态",
    "RebateStatusTxt1": "待发放",
    "RebateStatusTxt2": "冻结中",
    "RebateStatusTxt3": "已回收",
    "RebateStatusTxt4": "已发放",
    "RebateRate": "返佣比例",
    "RebateRateTip": "返佣对象在交易者所在的返佣级别的返佣比例",
    "marginCoin": "保证金币种",
    "searchUidTip": "交易并产生返佣的人",
    "returnAmount": "返佣金额",
    "returnAmountTip": "级差经纪人返佣金额 = 手续费*返佣比例 - 已发给下级的返佣",
    "agentEmail": "邮箱",
    "agentPhone": "手机",
    "isKYC": "是否KYC",
    "yes": "是",
    "no": "否",
    "isContract": "是否开通合约",
    "isInContract": "是否入金合约",
    "isTradeContract": "是否交易合约",
    "openContractTime": "开通合约时间",
    "agentEmaiPhone": "邮箱/手机",
    "pidTip2": "直属上级UID",
    "Region": "地区",
    "agentKey": "Key值",
    "agentValue": "Value值",
    "agentDesc": "描述",
    "agentDescErr": "请输入描述",
    "agentAccount": "经纪人奖励账户",
    "Transfer": "转账",
    "agentAccountTip": "当账户余额为0时，系统会暂停发放经纪人的返佣",
    "agentRatio": "普通用户直推比例",
    "agentRatioSet": "普通用户直推比例设置",
    "explain": "说明",
    "explainTip1": "1. 用于设置本商户普通用户推荐好友获得合约交易返佣的比例",
    "explainTip2": "2. 此金额若配置为0，则不支持普通用户返佣",
    "agentSet": "设置",
    "agentBalance": "(余额:{balance})",
    "agentRoleName": "角色",
    "Freeze": "冻结",
    "Unfreeze": "解冻",
    "Delete": "删除",
    "FreezeTip": "冻结后该经纪人的返佣参与计算但不进行发放。你确定冻结该经纪人吗？",
    "UnfreezeTip": "解冻后冻结期间未发放的返佣将一并发送给该经纪人。你确定解冻该经纪人吗？",
    "DeleteTip": "删除后该经纪人将不再享受返佣。你确定删除该经纪人吗？",
    "addBroker": "添加经纪人",
    "editBroker": "编辑经纪人",
    "userInfo": "用户信息",
    "roleName": "角色名称",
    "Sharetype": "分成方式",
    "Creationtime": "创建时间",
    "Brokersincluded": "所含经纪人数",
    "deleteRole": "你确定删除该角色吗？",
    "returnTypeTip1": "假如A、B的一级返佣比例为60%，二级返佣比例为40% 用户C产生手续费为10 USDT Case1：邀请关系: A-->B-->C 返佣: C-->B：6 USDT； C-->A:4 USDT Case2：邀请关系: B-->C (无间接邀请人) 返佣: C-->B：6 USDT",
    "returnTypeTip2": "假如A返佣比例为60%，B返佣比例为40% 用户C产生手续费为10 USDT Case1：邀请关系: A-->B-->C 返佣: C-->B：4 USDT； C-->A:2 USDT Case2：邀请关系: B-->C (无间接邀请人) 返佣: C-->B：4 USDT",
    "returnTypeTip3": "此类经纪人下级分成方式按照设定比例进行分成。",
    "agentLevel": "级",
    "agentLevelErr": "请输入0~99.99之间的数字",
    "agentLevelErr2": "请输入1~{kvMaxLevel}的整数",
    "deleteAgent": "当前角色所含经纪人数不为0，无法删除！",
    "addRole": "添加角色",
    "editRole": "编辑角色",
    "futuresBroker": "合约经纪人",
    "confirm": "确认",
    "noLogin": "登录已过期！",
    "brokerRewardAccount": "公司：邀请人返利奖金账户",
    "googleCodeTip": "请前往合约后台绑定谷歌验证码!",
    "searchType": "搜索类别",
    "agentSpot": "现货",
    "agentFutures": "合约",
    "tradeTime": "交易日期",
    "agentTit": "经纪人",
    "agentDownNum": "直属下级人数",
    "agentTeamNum": "团队人数",
    "agentInMoneyNum": "入金人数",
    "agentTradeNum": "交易人数",
    "agentTotalassetU": "总资产(USDT)",
    "agentInflowU": "流入(USDT)",
    "agentOutflowU": "流出(USDT)",
    "agentCurrentPositionU": "持仓额(USDT)",
    "agentTransactionVolumeU": "交易额（USDT）",
    "agentFeeU": "手续费(USDT)",
    "agentReturnU": "返佣(USDT)",
    "agentBreadTit": "直属下级",
    "dayNewUnderDownLevel": "每日新增直属下级",
    "dayNewDownLevel": "每日新增下级",
    "dayNewDownLevelAgent": "每日新增下级经纪人",
    "dayNewDownLevelTrade": "下级每日交易额(USDT)",
    "overInvitedUsers": "每日新增受邀用户数",
    "overAddAgentUsers": "每日新增合约经纪人",
    "overReturn": "每日发放返佣(USDT)",
    "settlementTime": "结算时间",
    "totalContracAssets": "合约总资产",
    "agentInflow": "流入",
    "agentOutflow": "流出",
    "agentIncome": "收益",
    "agentTransfer": "划转",
    "agentGrant": "发放",
    "agentUidAccount": "UID/账户",
    "notInviteNum": "不显示邀请人数为0的经纪人",
    "notInviteNumTwo": "不显示邀请人数为0的用户",
    "totalContracAssetsTip": "此时的合约账户中的资产，合约总资产 = 钱包余额 + 未实现盈亏",
    "WalletBalanceTip": "此时合约账户的钱包余额，钱包余额 = 余额账户 + 逐仓保证金 + 冻结保证金",
    "agentInflowTip": "在所选时间段内转入合约账户的资产",
    "agentOutflowTip": "在所选时间段内转出合约账户的资产",
    "agentIncomeTip": "在所选时间段内合约账户的收益",
    "agentReturnLevelTip": "用户是当前经纪人的的第几级下级",
    "agentDownNumTip": "此时，下级经纪人直接邀请的人数",
    "agentTeamNumTip": "最近一次脚本统计时，下级经纪人返佣范围内的人数",
    "agentInMoneyNumTip": "时间及下级经纪人返佣范围内，有过一次现货向合约的转账的人数",
    "agentTradeNumTip": "时间及下级经纪人返佣范围内，有过一笔合约交易的人数",
    "agentTotalassetUTip": "最近一次脚本统计时，所有返佣范围内用户资产的总和，非U币种折算成USDT，包含全仓保证金，逐仓保证金，冻结保证金和未实现盈亏",
    "agentInflowUTip": "时间及下级经纪人返佣范围内，所有划入合约账户金额的总和。非U币种折算成USDT，包含合约赠金。",
    "agentOutflowUTip": "时间及下级经纪人返佣范围内，所有划出合约账户金额的总和。非U币种折算成USDT，包含合约赠金",
    "agentCurrentPositionUTip": "最近一次脚本统计，持仓量为所有下级经纪人返佣范围内用户仓位头寸价值之和，非U币种折算成USDT",
    "agentTransactionVolumeUTip": "时间及下级经纪人返佣范围内，团队的交易额之和；包含开仓和平仓，不包含模拟合约；非U币种折算成USDT",
    "agentFeeUTip": "时间及下级经纪人返佣范围内，总用户交易产生的总手续费，非U币种折算成USDT",
    "agentReturnUTip": "该时间段内，下级经纪人获得的返佣之和，非U币种折算成USDT",
    "agentOrderNum": "订单号",
    "transferOut": "转出",
    "entrustedValue": "委托价值",
    "transferToCo": "币币到合约",
    "transferOutCo": "合约到币币",
    "roleTypeNote": "注：该角色配置时需要注意多层级时返佣的总比例",
    "agentOperationPermissionTip": "选择后，该角色经纪人可添加下级经纪人，并对下级经纪人进行编辑角色、冻结、删除操作，不选择则客户端对经纪人隐藏操作按钮。",
    "noAgentOperationPermission": "当前角色无该操作权限",
    "rebateStatusTip1": "待发放：已统计还未发放的返佣数据",
    "rebateStatusTip2": "冻结中：已统计但由于经纪人被冻结还未发放的返佣数据",
    "rebateStatusTip3": "已发放：已统计已发放的返佣数据",
    "rebateStatusTip4": "已回收：返佣在冻结中，经纪人被删除后该部分返佣不再发放",

  },
  "editInvitationCode": {
    "customCode": "自定义邀请码",
    "originalCode": "原邀请码",
    "newCode": "新邀请码",
    "placeholder": "6-9个大写字母或数字",
    "errotText": "请输入6-9个大写字母或数字",
    "errotText2": "不可与原邀请码一致",
    "note": "注：邀请码修改成功后，邀请链接会被同步修改，旧的邀请码和邀请链接将会失效。",
    "emailTip": "发送邮件提醒"
  },
  "returnLevel": {
    "t1": "返佣等级",
    "t2": "商户",
    "t3": "状态",
    "t4": "最高返佣等级",
    "t5": "添加时间",
    "t6": "更新时间",
    "t7": "操作",
    "t8": "请输入最高返佣等级",
    "t9": "开启",
    "t10": "关闭",
    "t11": "添加",
    "t12": "编辑",
    "t13": "保存",
    "t14": "取消",
    "t15": "搜索",
    "t16": "重置"
  },
  "walletBonus": {
    "t1": "自返佣"
  }
};
